import React from "react";
import "./TeamMemberCard.css"; // Create this CSS file for styling

const TeamMemberCard = ({ name, title, description }) => {
  return (
    <div className="team-member-card">
      <div className="image-placeholder"></div>
      <div className="info-container">
        <div className="name-title">
          <h3 className="name">{name}</h3>          
        </div>
        <div className="team-member-desc">
          <h4 className="title">{title}</h4>
          <p className="description">{description}</p>
        </div>        
      </div>
    </div>
  );
};

export default TeamMemberCard;
